<template>
  <baseEdit />
</template>

<script>
  import baseEdit from './baseEdit';

  export default {
    name: 'payBillEdit',
    components: {
      baseEdit,
    },
  };
</script>
